import React, {useState} from 'react'
import {gql, useMutation,useQuery} from "@apollo/client";
import '../App.css';

const GET_ENTRADA = gql `
query getEntradas{
  getEntradas{
    _id
   fecha
   concepto
   cantidad
  } 
}`



const ELIMINAR_ENTRADA = gql`mutation eliminarEntrada($id:ID!){
eliminarEntrada(_id:$id)
}`


const ACTUALIZAR_ENTRADA = gql`
  mutation editarEntrada($id: ID!, $nuevaCantidad: Int) {
    editarEntrada(_id: $id, cantidad: $nuevaCantidad) {
      _id
      fecha
      concepto
      cantidad
    }
  }
`;


function GetEntrada() {
  const [filtroNumero, setFiltroNumero] = useState("");
  
  const [editingEntry, setEditingEntry] = useState(null);
  const [nuevaCantidad, setNuevaCantidad] = useState(0);
  const [editarEntrada] = useMutation(ACTUALIZAR_ENTRADA)
   
    const {loading, error, data} = useQuery(GET_ENTRADA);
    const [eliminarEntrada] = useMutation(ELIMINAR_ENTRADA, {
      refetchQueries: [{ query: GET_ENTRADA }]
    });

  
   
 
  
      
    if(loading) return <p>Esperando resultados...</p>;
        if(error) return <p>Error</p>;

        
        
        const totalEntradas=data.getEntradas.reduce((acumulador, entrada) => acumulador + entrada.cantidad, 0)
        const reversedData = data.getEntradas.slice().reverse();

        const comienzaConNumero = (numero, entradaCantidad) => {
          return entradaCantidad.toString().startsWith(numero);
        };

    return (
      <div>
        <div className="card card-total">
          <h1>Total ingresos</h1>
          <h1>{totalEntradas}</h1>
        </div>
        <div className="container">
        <form>
            <label htmlFor="filtroNumero">Filtrar por Cantidad:</label>
            <input
              type="number"
              id="filtroNumero"
              value={filtroNumero}
              onChange={(e) => setFiltroNumero(e.target.value)}
            />
            <button type="submit">Aplicar Filtro</button>
          </form>
          <div className="row">
            {reversedData.map((entrada) => {
              if (filtroNumero === "" || comienzaConNumero(filtroNumero, entrada.cantidad)) {
                return (
                  <div className="card card-entrada col-xs-12 col-xl-4 col-sm-6" key={entrada._id}>
                    <div className="card-body">
                      <h3 className="card-title">{entrada.concepto}</h3>
                      <h4 className="card-text">{entrada.fecha}</h4>
                      <h4 className="card-text">{entrada.cantidad}</h4>
                      <button
                        className="btn btn-danger"
                        onClick={() => {
                          eliminarEntrada({ variables: { id: entrada._id } });
                        }}
                        disabled={loading}
                      >
                        eliminar
                      </button>
                      {editingEntry === entrada._id ? (
                        <>
                          <input
                            type="number"
                            value={nuevaCantidad}
                            onChange={(e) => setNuevaCantidad(parseInt(e.target.value))}
                          />
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              editarEntrada({
                                variables: { id: entrada._id, nuevaCantidad },
                              });
                              setEditingEntry(null);
                              setNuevaCantidad(0);
                            }}
                          >
                            Guardar
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              setEditingEntry(entrada._id);
                              setNuevaCantidad(entrada.cantidad);
                            }}
                          >
                            Editar
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                );
              } else {
                return null;
              }
            })}
          </div>
        </div>
      </div>
    );
}

export default GetEntrada